<template>
  <el-dialog
    title="导入"
    :visible.sync="dialogVisible"
    width="40%"
    @close="closeDialog"
  >
    <div class="step-content">
      <div :class="['step-item', isActive == 1 ? 'active' : 'unActive']">
        {{ isActive == 1 ? 1 : '√' }}
      </div>
      <span class="step-title">上传模板</span>
      <div :class="['step-line', isActive == 2 ? 'active' : '']"></div>
      <div :class="['step-item', isActive == 2 ? 'active' : '']">2</div>
      <span class="step-title">查看结果</span>
    </div>
    <div class="upload-situation">
      <div class="upload-file" v-if="isActive == 1">
        <el-upload
          class="upload-demo"
          drag
          :headers="uploadHeader"
          :action="fileUpload"
          multiple
          :limit="1"
          accept=".xlsx, .xls"
          :file-list="fileList"
          :on-success="uploadSuccess"
          :on-exceed="handleExceed"
          :before-upload="getFile"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        </el-upload>
        <div class="el-upload__tip" slot="tip">
          <div>说明</div>
          <div class="text">
            只支持上传Excel格式的文件。政策数据更新方式为增量更新
          </div>
          <div>如何填写规范的表格？</div>
          <div class="highlight-text" @click="downloadFile()">
            点击此处下载模版
          </div>
        </div>
      </div>
      <div class="upload-success" v-else>
        <div><i class="el-icon-success"></i></div>
        <div class="tips">导入成功</div>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog()" v-if="isActive == 1">取 消</el-button>
      <el-button type="primary" @click="sure()" v-if="isActive == 1"
        >确 定</el-button
      >
      <el-button type="primary" @click="closeDialog()" v-if="isActive == 2"
        >关 闭</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import axios from 'axios'
import { getToken } from '@utils'
import {
  downloadFile,
  importPolicyData,
  fileUpload
} from '@api/yardPolicy/policyManagement/index'
export default {
  name: 'ImportPolicy',
  data() {
    return {
      dialogVisible: false,
      isActive: 1,
      fileList: [],
      uploadHeader: {
        Authorization: 'Bearer ' + getToken()
      },
      fileUpload,
      hideUpload: false,
      file: null
    }
  },
  props: {
    dialogImport: {
      type: Boolean,
      default: true
    }
  },
  watch: {},
  mounted() {
    this.dialogVisible = this.dialogImport
  },
  methods: {
    sure() {
      if (!this.file) {
        this.$message.warning('请选择要上传的文件！')
      } else {
        let fd = new FormData()
        fd.append('file', this.file)
        axios
          .post('/prod-api/lishui-gov/govPolicy/importPolicyData', fd, {
            headers: {
              Authorization: 'Bearer ' + getToken()
            }
          })
          .then((res) => {
            if (res.data.code == '0000') {
              this.$message.success(res.data.msg)
              this.isActive = 2
            }
          })
      }
    },
    handleExceed() {
      this.$message.warning('当前限制选择 1 个文件，已上传了1个文件')
    },
    getFile(file) {
      this.file = file
    },
    uploadSuccess(response, file, fileList) {
      if (response.code == '0000') {
        console.log(fileList)
      }
    },
    closeDialog() {
      this.dialogVisible = false
      if (this.isActive == 2) {
        this.$emit('updateData')
      }
      this.$emit('closeImportDialog', false)
    },
    // 模板下载
    downloadFile() {
      downloadFile()
    }
  }
}
</script>

<style lang="scss" scoped>
$common-color: rgba(24, 144, 255, 1);
.step-content {
  display: flex;
  justify-content: center;
  align-items: center;
  .step-item {
    width: 26px;
    height: 26px;
    line-height: 26px;
    border-radius: 50%;
    border: 1px solid #eee;
    text-align: center;
    color: #ccc;
    &.active {
      background: $common-color;
      color: #fff;
    }
    &.unActive {
      color: $common-color;
      border-color: $common-color;
    }
  }
  .step-title {
    display: inline-block;
    margin: 5px;
  }
  .step-line {
    width: 300px;
    border-top: 0.8px solid #eee;
    margin: 0 10px;
    &.active {
      border-color: rgba(24, 144, 255, 0.5);
    }
  }
}
.upload-situation {
  width: 500px;
  margin: 20px auto;
  /deep/.el-upload-dragger {
    width: 500px;
  }
  .el-upload__tip {
    div {
      font-size: 14px;
      line-height: 30px;
    }
    .text {
      color: rgba(0, 0, 0, 0.5);
    }
    .highlight-text {
      color: $common-color;
      cursor: pointer;
    }
  }
  .upload-success {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    i {
      font-size: 60px;
      color: #52c41a;
      margin: 60px 0;
    }
    .tips {
      font-size: 16px;
    }
  }
}
</style>
